<mat-dialog-content>
    <mat-icon class="warning" color="warn">error</mat-icon>
    <h1>Visszahívás megerősítése</h1>
    <span>Biztosan vissza akarja hívni a fizetési kérelmet? A művelet nem visszavonahtó.</span>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>VISSZA</button>
    <button mat-flat-button color="warn" (click)="onYesClick()">MEGERŐSÍTÉS</button>
</mat-dialog-actions>